/* int-l4-teasers-scroll.js: moved verbatim from snippets/int-product-teasers.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
if (!window.__intTeaserScrollInit) {
  window.__intTeaserScrollInit = true;
  document.addEventListener('click', function(e) {
    var el = e.target && e.target.closest('[data-int-scroll]');
    if (!el) return;
    var t = document.querySelector(el.getAttribute('data-int-scroll'));
    if (!t) return;
    e.preventDefault();
    window.__intReturnY = window.pageYOffset;
    var OFFSET = 90;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - OFFSET, behavior: 'smooth' });
    setTimeout(function() {
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - OFFSET, behavior: 'smooth' });
    }, 700);
  });
}


(function() {
  var outer = document.getElementById('int-sig-outer');
  var cover = document.querySelector('.int-cxsig__cover');
  if (!outer) return;

  var revealed = false;
  function revealSig() {
    if (revealed) return;
    revealed = true;
    outer.classList.add('is-visible');
    if (cover) setTimeout(function() { cover.classList.add('is-revealed'); }, 300);
  }

  function isInView() {
    var rect = outer.getBoundingClientRect();
    if (window.innerWidth >= 768) {
      return rect.top < window.innerHeight - 60;
    } else {
      return rect.bottom < window.innerHeight - 40;
    }
  }

  if (window.innerWidth >= 768) {
    
    window.addEventListener('scroll', function onFirstScroll() {
      window.removeEventListener('scroll', onFirstScroll);
      revealSig();
    }, { once: true, passive: true });

  } else {
    function checkSig() {
      var rect = outer.getBoundingClientRect();
      if (rect.bottom < window.innerHeight - 20) {
        window.removeEventListener('scroll', checkSig);
        revealSig();
      }
    }
    window.addEventListener('scroll', checkSig, { passive: true });
  }
})();


(function() {
  function init() {
    var quote = document.querySelector('p.int-brand-quote__text');
    if (!quote) return;
    var done = false;
    function revealQuote() { if (done) return; done = true; quote.classList.add('is-visible'); }
    if (window.innerWidth < 768) {
      setTimeout(revealQuote, 450);
    } else {
      new IntersectionObserver(function(entries, obs) {
        if (entries[0].isIntersecting) { obs.disconnect(); revealQuote(); }
      }, { threshold: 0.2 }).observe(quote);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


(function() {
  var thumbs = document.querySelectorAll('.int-teaser__thumb-link');
  if (!thumbs.length) return;

  function attachObserver() {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var baseDelay = window.innerWidth >= 768 ? 200 : 0;
          var stagger = el.closest('.int-teaser--word') ? 200 : 0;
          setTimeout(function() { el.classList.add('is-visible'); }, baseDelay + stagger);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    thumbs.forEach(function(t) { obs.observe(t); });
  }

  if (window.innerWidth >= 768) {
    attachObserver();
  } else {
    var scrolled = false;
    window.addEventListener('scroll', function onFirstScroll() {
      if (scrolled) return; scrolled = true;
      window.removeEventListener('scroll', onFirstScroll);
      attachObserver();
    }, { passive: true });
  }
})();


(function() {
  function removeHide() {
    var sp = document.querySelector('h1.product__title span.title-main');
    if (sp) sp.style.setProperty('opacity', '1', 'important');
  }
  function splitTitle() {
    var span = document.querySelector('h1.product__title span.title-main')
            || document.querySelector('.product__title .title-main');
    if (!span) return false;
    if (span.dataset.intSplit) { removeHide(); return true; }
    var txt = span.textContent.trim();
    var idx = txt.indexOf(' – ');
    if (idx === -1) idx = txt.indexOf(' - ');
    if (idx === -1) { span.dataset.intSplit = '1'; removeHide(); return true; }
    var word  = txt.slice(0, idx).trim();
    var photo = txt.slice(idx + 3).trim()
                   .replace(/^["“”]+/, '').replace(/["“”]+$/, '');
    span.innerHTML = word + ' <span class="int-title__photo" data-wg-notranslate>' + photo + '</span>';
    span.dataset.intSplit = '1';
    removeHide();
    return true;
  }
  function trySplit() { if (!splitTitle()) setTimeout(trySplit, 30); }
  if (!splitTitle()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trySplit);
    else setTimeout(trySplit, 30);
  }
})();


(function() {
  var btn = document.getElementById('int-back-top');
  if (!btn) return;
  document.documentElement.classList.add('int-has-backtop');

  
  
  function place() {
    
    var fab = document.querySelector('.Avada-Faqs_Button.bottom');
    if (fab) {
      var fs = window.getComputedStyle(fab);
      var fr = fab.getBoundingClientRect();
      if (fs.display !== 'none' && fs.visibility !== 'hidden' && fr.height > 24) {
        var selfH = btn.getBoundingClientRect().height || 38;
        var fabCentre = (window.innerHeight - fr.bottom) + fr.height / 2;
        document.documentElement.style.setProperty(
          '--int-bt-bottom', Math.round(fabCentre - selfH / 2) + 'px');
        return;
      }
    }
    var bar = null;
    var candidates = document.querySelectorAll('#int-sticky-atc, [class*="int-sticky-atc"]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.getAttribute('data-visible') === '0') continue;
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden') {
        var h = el.getBoundingClientRect().height;
        if (h > 24) { bar = h; break; }
      }
    }
    document.documentElement.style.setProperty(
      '--int-bt-bottom', (bar ? Math.round(bar) + 12 : 26) + 'px');
  }
  place();
  window.addEventListener('resize', place, { passive: true });
  setTimeout(place, 600);
  setTimeout(place, 2000);
  
  (function() {
    function watch() {
      var sticky = document.getElementById('int-sticky-atc');
      if (!sticky) return false;
      if (!sticky.__intBtWatched) {
        sticky.__intBtWatched = true;
        new MutationObserver(function() {
          
          place();
          setTimeout(place, 280);
        }).observe(sticky, { attributes: true, attributeFilter: ['data-visible', 'data-ready'] });
      }
      place();
      return true;
    }
    if (!watch()) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
      window.addEventListener('load', watch);
    }
  })();

  var visible = false;
  window.addEventListener('scroll', function() {
    var s = window.pageYOffset > 400;
    if (s !== visible) { visible = s; btn.classList.toggle('is-visible', s); place(); }
  }, { passive: true });
  btn.addEventListener('click', function() {
    var y = window.__intReturnY;
    if (typeof y === 'number' && y < window.pageYOffset - 40) {
      window.scrollTo({ top: y, behavior: 'smooth' });
      window.__intReturnY = null;
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
})();
});
